// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/agent/v1/agent.proto (package mono.agent.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { ListValue, Message as Message$1, proto3, protoInt64, Struct, Timestamp } from "@bufbuild/protobuf";
import { RfiEvidenceDraft, RfiEvidenceSource } from "../../datagateway/v1/rfi_evidence_pb";
/**
 * @generated from message mono.agent.v1.GenerateRfiDraftRequest
 */ export class GenerateRfiDraftRequest extends Message$1 {
    static fromBinary(bytes, options) {
        return new GenerateRfiDraftRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GenerateRfiDraftRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GenerateRfiDraftRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GenerateRfiDraftRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Existing owned conversation, or empty to create one.
   *
   * @generated from field: string conversation_id = 1;
   */ _define_property(this, "conversationId", ""), /**
   * @generated from field: string rfi_response_project_id = 2;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string section_id = 3;
   */ _define_property(this, "sectionId", ""), /**
   * @generated from field: string question_id = 4;
   */ _define_property(this, "questionId", ""), /**
   * @generated from field: repeated mono.datagateway.v1.RfiEvidenceSource sources = 5;
   */ _define_property(this, "sources", []), /**
   * draft (default), summarize, compress, or check. No unsaved browser prose.
   *
   * @generated from field: string intent = 6;
   */ _define_property(this, "intent", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GenerateRfiDraftRequest, "runtime", proto3);
_define_property(GenerateRfiDraftRequest, "typeName", "mono.agent.v1.GenerateRfiDraftRequest");
_define_property(GenerateRfiDraftRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "conversation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "question_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "sources",
            kind: "message",
            T: RfiEvidenceSource,
            repeated: true
        },
        {
            no: 6,
            name: "intent",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.agent.v1.GenerateRfiDraftResponse
 */ export class GenerateRfiDraftResponse extends Message$1 {
    static fromBinary(bytes, options) {
        return new GenerateRfiDraftResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GenerateRfiDraftResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GenerateRfiDraftResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GenerateRfiDraftResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string conversation_id = 1;
   */ _define_property(this, "conversationId", ""), /**
   * @generated from field: string tool_call_id = 2;
   */ _define_property(this, "toolCallId", ""), /**
   * @generated from field: mono.datagateway.v1.RfiEvidenceDraft draft = 3;
   */ _define_property(this, "draft", void 0), /**
   * Same result shape as the saved write-to-document review card, with rfiProposal metadata.
   *
   * @generated from field: google.protobuf.Struct proposal = 4;
   */ _define_property(this, "proposal", void 0), /**
   * Nonmutating deterministic DOCX preview; adoption replaces the entire section document.
   *
   * @generated from field: bytes preview_docx = 5;
   */ _define_property(this, "previewDocx", new Uint8Array(0));
        proto3.util.initPartial(data, this);
    }
}
_define_property(GenerateRfiDraftResponse, "runtime", proto3);
_define_property(GenerateRfiDraftResponse, "typeName", "mono.agent.v1.GenerateRfiDraftResponse");
_define_property(GenerateRfiDraftResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "conversation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tool_call_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "draft",
            kind: "message",
            T: RfiEvidenceDraft
        },
        {
            no: 4,
            name: "proposal",
            kind: "message",
            T: Struct
        },
        {
            no: 5,
            name: "preview_docx",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        }
    ]));
/**
 * @generated from message mono.agent.v1.DecideDocumentProposalRequest
 */ export class DecideDocumentProposalRequest extends Message$1 {
    static fromBinary(bytes, options) {
        return new DecideDocumentProposalRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DecideDocumentProposalRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DecideDocumentProposalRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DecideDocumentProposalRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string conversation_id = 1;
   */ _define_property(this, "conversationId", ""), /**
   * @generated from field: string tool_call_id = 2;
   */ _define_property(this, "toolCallId", ""), /**
   * accepted | edited | rejected | partial (edited is RFI-only; partial is delivery-only).
   *
   * @generated from field: string decision = 3;
   */ _define_property(this, "decision", ""), /**
   * Per-row outcomes for delivery-action proposals (ok/fail + message).
   * Persisted onto the saved tool result so a fresh session can restore
   * which rows already applied.
   *
   * @generated from field: repeated mono.agent.v1.DeliveryActionRowResult row_results = 4;
   */ _define_property(this, "rowResults", []), /**
   * RFI edited only: explicit human-reviewed full-section DOCX bytes.
   * Retry with the identical bytes; accepted/rejected must omit this field.
   *
   * @generated from field: bytes reviewed_content = 5;
   */ _define_property(this, "reviewedContent", new Uint8Array(0)), /**
   * Only valid with decision "accepted" on a document_write proposal. shanks
   * records the accept (same persistence as a normal accept) but performs no
   * apply and writes no audit event, because the caller (zou
   * ApplyAssistOperations) already did. It only affects the caller's own
   * conversation record (AWR-5: labels never grant).
   *
   * @generated from field: bool applied_externally = 6;
   */ _define_property(this, "appliedExternally", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DecideDocumentProposalRequest, "runtime", proto3);
_define_property(DecideDocumentProposalRequest, "typeName", "mono.agent.v1.DecideDocumentProposalRequest");
_define_property(DecideDocumentProposalRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "conversation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tool_call_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "decision",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "row_results",
            kind: "message",
            T: DeliveryActionRowResult,
            repeated: true
        },
        {
            no: 5,
            name: "reviewed_content",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        },
        {
            no: 6,
            name: "applied_externally",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.agent.v1.DeliveryActionRowResult
 */ export class DeliveryActionRowResult extends Message$1 {
    static fromBinary(bytes, options) {
        return new DeliveryActionRowResult().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeliveryActionRowResult().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeliveryActionRowResult().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeliveryActionRowResult, a, b);
    }
    constructor(data){
        super(), /**
   * ok | fail
   *
   * @generated from field: string status = 1;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string message = 2;
   */ _define_property(this, "message", ""), /**
   * Ids returned by a successful apply (for $rowN.field refs after reload).
   *
   * @generated from field: map<string, string> apply = 3;
   */ _define_property(this, "apply", {});
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeliveryActionRowResult, "runtime", proto3);
_define_property(DeliveryActionRowResult, "typeName", "mono.agent.v1.DeliveryActionRowResult");
_define_property(DeliveryActionRowResult, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "apply",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 9 /* ScalarType.STRING */ 
            }
        }
    ]));
/**
 * @generated from message mono.agent.v1.DecideDocumentProposalResponse
 */ export class DecideDocumentProposalResponse extends Message$1 {
    static fromBinary(bytes, options) {
        return new DecideDocumentProposalResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DecideDocumentProposalResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DecideDocumentProposalResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DecideDocumentProposalResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string decision = 1;
   */ _define_property(this, "decision", ""), /**
   * @generated from field: string document_key = 2;
   */ _define_property(this, "documentKey", ""), /**
   * Set when an accepted proposal created a document: the new document's id
   * (the shirohige id the editor opens) and its saved name.
   *
   * @generated from field: string document_id = 3;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string document_name = 4;
   */ _define_property(this, "documentName", ""), /**
   * Set when the created document belongs to a proposal volume: the volume
   * document id the assistant reads and writes it by.
   *
   * @generated from field: string volume_document_id = 5;
   */ _define_property(this, "volumeDocumentId", ""), /**
   * Set when an accepted publish proposal ran: one line saying what was done
   * (files added to the project's search, an analysis started).
   *
   * @generated from field: string receipt = 6;
   */ _define_property(this, "receipt", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DecideDocumentProposalResponse, "runtime", proto3);
_define_property(DecideDocumentProposalResponse, "typeName", "mono.agent.v1.DecideDocumentProposalResponse");
_define_property(DecideDocumentProposalResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "decision",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "document_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "document_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "volume_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "receipt",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ChatPin is one extra bind on a personal unshared /assistant thread
 * (vision 15). Same surface vocabulary as ChatContext.surface. Desk-bound
 * and shared chats must not send these; the server drops them.
 *
 * @generated from message mono.agent.v1.ChatPin
 */ export class ChatPin extends Message$1 {
    static fromBinary(bytes, options) {
        return new ChatPin().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ChatPin().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ChatPin().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ChatPin, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string surface = 1;
   */ _define_property(this, "surface", ""), /**
   * @generated from field: string pursuit_id = 2;
   */ _define_property(this, "pursuitId", ""), /**
   * @generated from field: string project_id = 3;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string program_id = 4;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string document_id = 5;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string volume_id = 6;
   */ _define_property(this, "volumeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ChatPin, "runtime", proto3);
_define_property(ChatPin, "typeName", "mono.agent.v1.ChatPin");
_define_property(ChatPin, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "surface",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "pursuit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "volume_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ChatContext is the turn envelope: where the user is standing. Omitted
 * (legacy clients) = today's behavior. Surface values (do not invent
 * aliases): root | assistant | capture_pursuit | rfi_response | proposal |
 * proposal_document | delivery_home | delivery_program | legal | qa |
 * finance | contracts.
 *
 * @generated from message mono.agent.v1.ChatContext
 */ export class ChatContext extends Message$1 {
    static fromBinary(bytes, options) {
        return new ChatContext().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ChatContext().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ChatContext().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ChatContext, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string surface = 1;
   */ _define_property(this, "surface", ""), /**
   * @generated from field: string pursuit_id = 2;
   */ _define_property(this, "pursuitId", ""), /**
   * @generated from field: string project_id = 3;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string program_id = 4;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string document_id = 5;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string volume_id = 6;
   */ _define_property(this, "volumeId", ""), /**
   * Extra binds. Honored only on owner-only private chats with no
   * project_id and no chat_shares. Cap 8. Each pin is Cerbos-checked
   * when an authorizer is wired; denied pins are omitted, not a 500.
   *
   * @generated from field: repeated mono.agent.v1.ChatPin pins = 7;
   */ _define_property(this, "pins", []), /**
   * Focus ids: the record the user is looking at (open drawer, duty
   * page, Docs preview). Empty when they are not focused on one.
   * "Comment on this" / "this date" must use these, never a guess.
   *
   * @generated from field: string occurrence_id = 8;
   */ _define_property(this, "occurrenceId", ""), /**
   * @generated from field: string duty_id = 9;
   */ _define_property(this, "dutyId", ""), /**
   * @generated from field: string work_product_id = 10;
   */ _define_property(this, "workProductId", ""), /**
   * @generated from field: string issue_id = 11;
   */ _define_property(this, "issueId", ""), /**
   * @generated from field: string comment_id = 12;
   */ _define_property(this, "commentId", ""), /**
   * @generated from field: string review_item_id = 13;
   */ _define_property(this, "reviewItemId", ""), /**
   * @generated from field: string artifact_id = 14;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string submission_id = 15;
   */ _define_property(this, "submissionId", ""), /**
   * @generated from field: string section_anchor = 17;
   */ _define_property(this, "sectionAnchor", ""), /**
   * @generated from field: string response_container_json = 18;
   */ _define_property(this, "responseContainerJson", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ChatContext, "runtime", proto3);
_define_property(ChatContext, "typeName", "mono.agent.v1.ChatContext");
_define_property(ChatContext, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "surface",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "pursuit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "volume_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "pins",
            kind: "message",
            T: ChatPin,
            repeated: true
        },
        {
            no: 8,
            name: "occurrence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "duty_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "work_product_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "issue_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "comment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "review_item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "submission_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "section_anchor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "response_container_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.agent.v1.ChatRequest
 */ export class ChatRequest extends Message$1 {
    static fromBinary(bytes, options) {
        return new ChatRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ChatRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ChatRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ChatRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string message = 1;
   */ _define_property(this, "message", ""), /**
   * @generated from field: string conversation_id = 2;
   */ _define_property(this, "conversationId", ""), /**
   * Ignored since the global-model-settings pivot: the active model is
   * server-resolved from admin settings (see GetChatModelSettings). Kept for
   * wire compatibility; logged for observability, never honored.
   *
   * @generated from field: string model_id = 3 [deprecated = true];
   * @deprecated
   */ _define_property(this, "modelId", ""), /**
   * @generated from field: repeated string file_ids = 4;
   */ _define_property(this, "fileIds", []), /**
   * @generated from field: string project_id = 5;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string user_id = 6;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string tenant_id = 7;
   */ _define_property(this, "tenantId", ""), /**
   * Nested envelope. When context.project_id is set it wins over
   * ChatRequest.project_id for LoadContext / RAG. Field 8 is the next
   * free number; do not reuse deprecated model_id = 3.
   *
   * @generated from field: mono.agent.v1.ChatContext context = 8;
   */ _define_property(this, "context", void 0), /**
   * Stable across retries of one logical submission; new submissions use a new ID.
   *
   * @generated from field: string submission_id = 9;
   */ _define_property(this, "submissionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ChatRequest, "runtime", proto3);
_define_property(ChatRequest, "typeName", "mono.agent.v1.ChatRequest");
_define_property(ChatRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "conversation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "model_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "file_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "context",
            kind: "message",
            T: ChatContext
        },
        {
            no: 9,
            name: "submission_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ChatResponse is a streamed response event from the agent.
 *
 * @generated from message mono.agent.v1.ChatResponse
 */ export class ChatResponse extends Message$1 {
    static fromBinary(bytes, options) {
        return new ChatResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ChatResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ChatResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ChatResponse, a, b);
    }
    constructor(data){
        super(), /**
   * Event type. One of:
   *   "conversation_id" — sent first; carries the conversation_id field
   *   "message"         — text content delta; carries `content`
   *   "tool_call"       — tool invocation; carries `tool_call`
   *   "tool_result"     — tool output; carries `tool_result`
   *   "artifact"        — artifact emitted; carries `artifact`
   *   "title"           — generated conversation title; carries `title`
   *   "done"            — terminal success
   *   "error"           — terminal error; carries `error`
   * Server-side EventToolCallDelta / EventToolCallEnd are coalesced into
   * tool_call (with arguments populated) by mapAgentEventToProto so the
   * wire stream carries one event per logical tool invocation.
   *
   * @generated from field: string event_type = 1;
   */ _define_property(this, "eventType", ""), /**
   * Text content for message events.
   *
   * @generated from field: string content = 2;
   */ _define_property(this, "content", ""), /**
   * Conversation ID (sent in first event).
   *
   * @generated from field: string conversation_id = 3;
   */ _define_property(this, "conversationId", ""), /**
   * Tool call details (for tool_call events).
   *
   * @generated from field: mono.agent.v1.ToolCall tool_call = 4;
   */ _define_property(this, "toolCall", void 0), /**
   * Tool result (for tool_result events).
   *
   * @generated from field: mono.agent.v1.ToolResult tool_result = 5;
   */ _define_property(this, "toolResult", void 0), /**
   * Error message (for error events).
   *
   * @generated from field: string error = 6;
   */ _define_property(this, "error", ""), /**
   * Artifact details (for artifact events).
   *
   * @generated from field: mono.agent.v1.Artifact artifact = 7;
   */ _define_property(this, "artifact", void 0), /**
   * Generated conversation title (for title events).
   *
   * @generated from field: string title = 8;
   */ _define_property(this, "title", ""), /**
   * Stable persisted row identities reconcile live output with refreshed history.
   *
   * @generated from field: string user_message_id = 9;
   */ _define_property(this, "userMessageId", ""), /**
   * @generated from field: string assistant_message_id = 10;
   */ _define_property(this, "assistantMessageId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ChatResponse, "runtime", proto3);
_define_property(ChatResponse, "typeName", "mono.agent.v1.ChatResponse");
_define_property(ChatResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "event_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "content",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "conversation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "tool_call",
            kind: "message",
            T: ToolCall
        },
        {
            no: 5,
            name: "tool_result",
            kind: "message",
            T: ToolResult
        },
        {
            no: 6,
            name: "error",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "artifact",
            kind: "message",
            T: Artifact
        },
        {
            no: 8,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "user_message_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "assistant_message_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.agent.v1.ToolCall
 */ export class ToolCall extends Message$1 {
    static fromBinary(bytes, options) {
        return new ToolCall().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ToolCall().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ToolCall().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ToolCall, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: google.protobuf.Struct arguments = 3;
   */ _define_property(this, "arguments", void 0), /**
   * Brief public action intent, separate from private reasoning and tool input.
   *
   * @generated from field: string purpose = 4;
   */ _define_property(this, "purpose", ""), /**
   * queued until execution actually begins, then running.
   *
   * @generated from field: string execution_state = 5;
   */ _define_property(this, "executionState", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ToolCall, "runtime", proto3);
_define_property(ToolCall, "typeName", "mono.agent.v1.ToolCall");
_define_property(ToolCall, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "arguments",
            kind: "message",
            T: Struct
        },
        {
            no: 4,
            name: "purpose",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "execution_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.agent.v1.ToolResult
 */ export class ToolResult extends Message$1 {
    static fromBinary(bytes, options) {
        return new ToolResult().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ToolResult().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ToolResult().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ToolResult, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tool_call_id = 1;
   */ _define_property(this, "toolCallId", ""), /**
   * @generated from field: string content = 2;
   */ _define_property(this, "content", ""), /**
   * @generated from field: bool is_error = 3;
   */ _define_property(this, "isError", false), /**
   * @generated from field: double duration_ms = 4;
   */ _define_property(this, "durationMs", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ToolResult, "runtime", proto3);
_define_property(ToolResult, "typeName", "mono.agent.v1.ToolResult");
_define_property(ToolResult, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tool_call_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "content",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "is_error",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "duration_ms",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * @generated from message mono.agent.v1.Artifact
 */ export class Artifact extends Message$1 {
    static fromBinary(bytes, options) {
        return new Artifact().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Artifact().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Artifact().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Artifact, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string kind = 3;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string content = 4;
   */ _define_property(this, "content", ""), /**
   * @generated from field: string source_attachment_id = 5;
   */ _define_property(this, "sourceAttachmentId", ""), /**
   * @generated from field: string source_url = 6;
   */ _define_property(this, "sourceUrl", ""), /**
   * @generated from field: string content_type = 7;
   */ _define_property(this, "contentType", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(Artifact, "runtime", proto3);
_define_property(Artifact, "typeName", "mono.agent.v1.Artifact");
_define_property(Artifact, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "content",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source_attachment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "source_url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "content_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.agent.v1.ListModelsRequest
 */ export class ListModelsRequest extends Message$1 {
    static fromBinary(bytes, options) {
        return new ListModelsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListModelsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListModelsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListModelsRequest, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListModelsRequest, "runtime", proto3);
_define_property(ListModelsRequest, "typeName", "mono.agent.v1.ListModelsRequest");
_define_property(ListModelsRequest, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.agent.v1.ListModelsResponse
 */ export class ListModelsResponse extends Message$1 {
    static fromBinary(bytes, options) {
        return new ListModelsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListModelsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListModelsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListModelsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.agent.v1.Model models = 1;
   */ _define_property(this, "models", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListModelsResponse, "runtime", proto3);
_define_property(ListModelsResponse, "typeName", "mono.agent.v1.ListModelsResponse");
_define_property(ListModelsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "models",
            kind: "message",
            T: Model,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.agent.v1.Model
 */ export class Model extends Message$1 {
    static fromBinary(bytes, options) {
        return new Model().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Model().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Model().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Model, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string provider = 3;
   */ _define_property(this, "provider", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(Model, "runtime", proto3);
_define_property(Model, "typeName", "mono.agent.v1.Model");
_define_property(Model, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "provider",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.agent.v1.ListConversationsRequest
 */ export class ListConversationsRequest extends Message$1 {
    static fromBinary(bytes, options) {
        return new ListConversationsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListConversationsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListConversationsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListConversationsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: int32 limit = 2;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: int32 offset = 3;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: string project_id = 4;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListConversationsRequest, "runtime", proto3);
_define_property(ListConversationsRequest, "typeName", "mono.agent.v1.ListConversationsRequest");
_define_property(ListConversationsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.agent.v1.ListConversationsResponse
 */ export class ListConversationsResponse extends Message$1 {
    static fromBinary(bytes, options) {
        return new ListConversationsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListConversationsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListConversationsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListConversationsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.agent.v1.Conversation conversations = 1;
   */ _define_property(this, "conversations", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListConversationsResponse, "runtime", proto3);
_define_property(ListConversationsResponse, "typeName", "mono.agent.v1.ListConversationsResponse");
_define_property(ListConversationsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "conversations",
            kind: "message",
            T: Conversation,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.agent.v1.GetConversationRequest
 */ export class GetConversationRequest extends Message$1 {
    static fromBinary(bytes, options) {
        return new GetConversationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetConversationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetConversationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetConversationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetConversationRequest, "runtime", proto3);
_define_property(GetConversationRequest, "typeName", "mono.agent.v1.GetConversationRequest");
_define_property(GetConversationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.agent.v1.GetConversationResponse
 */ export class GetConversationResponse extends Message$1 {
    static fromBinary(bytes, options) {
        return new GetConversationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetConversationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetConversationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetConversationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.agent.v1.Conversation conversation = 1;
   */ _define_property(this, "conversation", void 0), /**
   * @generated from field: repeated mono.agent.v1.Message messages = 2;
   */ _define_property(this, "messages", []), /**
   * True when the caller may view the transcript but may not continue or apply changes.
   *
   * @generated from field: bool read_only = 3;
   */ _define_property(this, "readOnly", false), /**
   * @generated from field: repeated mono.agent.v1.ChatSubmissionStatus submissions = 4;
   */ _define_property(this, "submissions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetConversationResponse, "runtime", proto3);
_define_property(GetConversationResponse, "typeName", "mono.agent.v1.GetConversationResponse");
_define_property(GetConversationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "conversation",
            kind: "message",
            T: Conversation
        },
        {
            no: 2,
            name: "messages",
            kind: "message",
            T: Message,
            repeated: true
        },
        {
            no: 3,
            name: "read_only",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "submissions",
            kind: "message",
            T: ChatSubmissionStatus,
            repeated: true
        }
    ]));
/**
 * UpdateConversationRequest carries the mutable subset of Conversation.
 *
 * title is always written — every caller submits it (Chat Settings on Save,
 * ChatHistory on inline rename). An empty title is a legitimate value and
 * will overwrite the stored value, but in practice the UI guards against
 * blank submission.
 *
 * description is `optional` (proto3 field-presence) so a caller that
 * doesn't know about description — notably the legacy ChatHistory
 * inline-rename — does NOT clobber a stored description by omitting the
 * field. Sending an explicit empty string clears it; omitting the field
 * leaves it alone.
 *
 * @generated from message mono.agent.v1.UpdateConversationRequest
 */ export class UpdateConversationRequest extends Message$1 {
    static fromBinary(bytes, options) {
        return new UpdateConversationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateConversationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateConversationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateConversationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * @generated from field: optional string description = 3;
   */ _define_property(this, "description", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateConversationRequest, "runtime", proto3);
_define_property(UpdateConversationRequest, "typeName", "mono.agent.v1.UpdateConversationRequest");
_define_property(UpdateConversationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        }
    ]));
/**
 * @generated from message mono.agent.v1.UpdateConversationResponse
 */ export class UpdateConversationResponse extends Message$1 {
    static fromBinary(bytes, options) {
        return new UpdateConversationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateConversationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateConversationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateConversationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.agent.v1.Conversation conversation = 1;
   */ _define_property(this, "conversation", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateConversationResponse, "runtime", proto3);
_define_property(UpdateConversationResponse, "typeName", "mono.agent.v1.UpdateConversationResponse");
_define_property(UpdateConversationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "conversation",
            kind: "message",
            T: Conversation
        }
    ]));
/**
 * @generated from message mono.agent.v1.DeleteConversationRequest
 */ export class DeleteConversationRequest extends Message$1 {
    static fromBinary(bytes, options) {
        return new DeleteConversationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteConversationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteConversationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteConversationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteConversationRequest, "runtime", proto3);
_define_property(DeleteConversationRequest, "typeName", "mono.agent.v1.DeleteConversationRequest");
_define_property(DeleteConversationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.agent.v1.DeleteConversationResponse
 */ export class DeleteConversationResponse extends Message$1 {
    static fromBinary(bytes, options) {
        return new DeleteConversationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteConversationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteConversationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteConversationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string message = 1;
   */ _define_property(this, "message", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteConversationResponse, "runtime", proto3);
_define_property(DeleteConversationResponse, "typeName", "mono.agent.v1.DeleteConversationResponse");
_define_property(DeleteConversationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.agent.v1.ListHistoryRequest
 */ export class ListHistoryRequest extends Message$1 {
    static fromBinary(bytes, options) {
        return new ListHistoryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListHistoryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListHistoryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListHistoryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: int32 limit = 2;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: int32 offset = 3;
   */ _define_property(this, "offset", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListHistoryRequest, "runtime", proto3);
_define_property(ListHistoryRequest, "typeName", "mono.agent.v1.ListHistoryRequest");
_define_property(ListHistoryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.agent.v1.ListHistoryResponse
 */ export class ListHistoryResponse extends Message$1 {
    static fromBinary(bytes, options) {
        return new ListHistoryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListHistoryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListHistoryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListHistoryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.agent.v1.Conversation conversations = 1;
   */ _define_property(this, "conversations", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListHistoryResponse, "runtime", proto3);
_define_property(ListHistoryResponse, "typeName", "mono.agent.v1.ListHistoryResponse");
_define_property(ListHistoryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "conversations",
            kind: "message",
            T: Conversation,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.agent.v1.Conversation
 */ export class Conversation extends Message$1 {
    static fromBinary(bytes, options) {
        return new Conversation().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Conversation().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Conversation().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Conversation, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string user_id = 3;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string model_id = 4;
   */ _define_property(this, "modelId", ""), /**
   * @generated from field: string project_id = 5;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */ _define_property(this, "updatedAt", void 0), /**
   * Free-form user-authored description, surfaced in the Chat Settings
   * modal. Backed by collab.conversations.description (text NOT NULL
   * DEFAULT ''); empty-string-as-unset on the wire.
   *
   * @generated from field: string description = 8;
   */ _define_property(this, "description", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(Conversation, "runtime", proto3);
_define_property(Conversation, "typeName", "mono.agent.v1.Conversation");
_define_property(Conversation, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "model_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.agent.v1.Message
 */ export class Message extends Message$1 {
    static fromBinary(bytes, options) {
        return new Message().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Message().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Message().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Message, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string conversation_id = 2;
   */ _define_property(this, "conversationId", ""), /**
   * @generated from field: string role = 3;
   */ _define_property(this, "role", ""), /**
   * @generated from field: string content = 4;
   */ _define_property(this, "content", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */ _define_property(this, "createdAt", void 0), /**
   * UIMessage-style parts (text / tool-call / tool-result / artifact / reasoning).
   * Browser callers render from `parts` when present and fall back to `content`
   * for legacy messages persisted before parts were tracked.
   *
   * @generated from field: google.protobuf.ListValue parts = 6;
   */ _define_property(this, "parts", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(Message, "runtime", proto3);
_define_property(Message, "typeName", "mono.agent.v1.Message");
_define_property(Message, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "conversation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "content",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "parts",
            kind: "message",
            T: ListValue
        }
    ]));
/**
 * @generated from message mono.agent.v1.TranscribeAudioRequest
 */ export class TranscribeAudioRequest extends Message$1 {
    static fromBinary(bytes, options) {
        return new TranscribeAudioRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TranscribeAudioRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TranscribeAudioRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TranscribeAudioRequest, a, b);
    }
    constructor(data){
        super(), /**
   * A browser MediaRecorder capture. The filename carries the container
   * (e.g. "dictation.webm"), which is how the transcriber tells formats apart.
   *
   * @generated from field: bytes audio = 1;
   */ _define_property(this, "audio", new Uint8Array(0)), /**
   * @generated from field: string audio_filename = 2;
   */ _define_property(this, "audioFilename", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(TranscribeAudioRequest, "runtime", proto3);
_define_property(TranscribeAudioRequest, "typeName", "mono.agent.v1.TranscribeAudioRequest");
_define_property(TranscribeAudioRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "audio",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        },
        {
            no: 2,
            name: "audio_filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.agent.v1.TranscribeAudioResponse
 */ export class TranscribeAudioResponse extends Message$1 {
    static fromBinary(bytes, options) {
        return new TranscribeAudioResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TranscribeAudioResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TranscribeAudioResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TranscribeAudioResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string text = 1;
   */ _define_property(this, "text", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(TranscribeAudioResponse, "runtime", proto3);
_define_property(TranscribeAudioResponse, "typeName", "mono.agent.v1.TranscribeAudioResponse");
_define_property(TranscribeAudioResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.agent.v1.UploadFileRequest
 */ export class UploadFileRequest extends Message$1 {
    static fromBinary(bytes, options) {
        return new UploadFileRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UploadFileRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UploadFileRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UploadFileRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bytes file_data = 1;
   */ _define_property(this, "fileData", new Uint8Array(0)), /**
   * @generated from field: string filename = 2;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: string content_type = 3;
   */ _define_property(this, "contentType", ""), /**
   * @generated from field: string user_id = 4;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string tenant_id = 5;
   */ _define_property(this, "tenantId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UploadFileRequest, "runtime", proto3);
_define_property(UploadFileRequest, "typeName", "mono.agent.v1.UploadFileRequest");
_define_property(UploadFileRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "file_data",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        },
        {
            no: 2,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "content_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.agent.v1.UploadFileResponse
 */ export class UploadFileResponse extends Message$1 {
    static fromBinary(bytes, options) {
        return new UploadFileResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UploadFileResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UploadFileResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UploadFileResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string filename = 2;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: string content_type = 3;
   */ _define_property(this, "contentType", ""), /**
   * @generated from field: int64 size = 4;
   */ _define_property(this, "size", protoInt64.zero), /**
   * @generated from field: int32 chunk_count = 5;
   */ _define_property(this, "chunkCount", 0), /**
   * @generated from field: string status = 6;
   */ _define_property(this, "status", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UploadFileResponse, "runtime", proto3);
_define_property(UploadFileResponse, "typeName", "mono.agent.v1.UploadFileResponse");
_define_property(UploadFileResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "content_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "size",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 5,
            name: "chunk_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.agent.v1.ListFilesRequest
 */ export class ListFilesRequest extends Message$1 {
    static fromBinary(bytes, options) {
        return new ListFilesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListFilesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListFilesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListFilesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListFilesRequest, "runtime", proto3);
_define_property(ListFilesRequest, "typeName", "mono.agent.v1.ListFilesRequest");
_define_property(ListFilesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.agent.v1.ListFilesResponse
 */ export class ListFilesResponse extends Message$1 {
    static fromBinary(bytes, options) {
        return new ListFilesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListFilesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListFilesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListFilesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.agent.v1.FileInfo files = 1;
   */ _define_property(this, "files", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListFilesResponse, "runtime", proto3);
_define_property(ListFilesResponse, "typeName", "mono.agent.v1.ListFilesResponse");
_define_property(ListFilesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "files",
            kind: "message",
            T: FileInfo,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.agent.v1.GetFileRequest
 */ export class GetFileRequest extends Message$1 {
    static fromBinary(bytes, options) {
        return new GetFileRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetFileRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetFileRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetFileRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetFileRequest, "runtime", proto3);
_define_property(GetFileRequest, "typeName", "mono.agent.v1.GetFileRequest");
_define_property(GetFileRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.agent.v1.GetFileResponse
 */ export class GetFileResponse extends Message$1 {
    static fromBinary(bytes, options) {
        return new GetFileResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetFileResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetFileResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetFileResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.agent.v1.FileInfo file = 1;
   */ _define_property(this, "file", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetFileResponse, "runtime", proto3);
_define_property(GetFileResponse, "typeName", "mono.agent.v1.GetFileResponse");
_define_property(GetFileResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "file",
            kind: "message",
            T: FileInfo
        }
    ]));
/**
 * @generated from message mono.agent.v1.GetFileChunksRequest
 */ export class GetFileChunksRequest extends Message$1 {
    static fromBinary(bytes, options) {
        return new GetFileChunksRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetFileChunksRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetFileChunksRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetFileChunksRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetFileChunksRequest, "runtime", proto3);
_define_property(GetFileChunksRequest, "typeName", "mono.agent.v1.GetFileChunksRequest");
_define_property(GetFileChunksRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.agent.v1.GetFileChunksResponse
 */ export class GetFileChunksResponse extends Message$1 {
    static fromBinary(bytes, options) {
        return new GetFileChunksResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetFileChunksResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetFileChunksResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetFileChunksResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string file_id = 1;
   */ _define_property(this, "fileId", ""), /**
   * @generated from field: string filename = 2;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: repeated mono.agent.v1.FileChunk chunks = 3;
   */ _define_property(this, "chunks", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetFileChunksResponse, "runtime", proto3);
_define_property(GetFileChunksResponse, "typeName", "mono.agent.v1.GetFileChunksResponse");
_define_property(GetFileChunksResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "file_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "chunks",
            kind: "message",
            T: FileChunk,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.agent.v1.DeleteFileRequest
 */ export class DeleteFileRequest extends Message$1 {
    static fromBinary(bytes, options) {
        return new DeleteFileRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteFileRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteFileRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteFileRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteFileRequest, "runtime", proto3);
_define_property(DeleteFileRequest, "typeName", "mono.agent.v1.DeleteFileRequest");
_define_property(DeleteFileRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.agent.v1.DeleteFileResponse
 */ export class DeleteFileResponse extends Message$1 {
    static fromBinary(bytes, options) {
        return new DeleteFileResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteFileResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteFileResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteFileResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string message = 1;
   */ _define_property(this, "message", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteFileResponse, "runtime", proto3);
_define_property(DeleteFileResponse, "typeName", "mono.agent.v1.DeleteFileResponse");
_define_property(DeleteFileResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.agent.v1.FileInfo
 */ export class FileInfo extends Message$1 {
    static fromBinary(bytes, options) {
        return new FileInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FileInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FileInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FileInfo, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string filename = 2;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: string content_type = 3;
   */ _define_property(this, "contentType", ""), /**
   * @generated from field: int64 size = 4;
   */ _define_property(this, "size", protoInt64.zero), /**
   * @generated from field: int32 chunk_count = 5;
   */ _define_property(this, "chunkCount", 0), /**
   * @generated from field: string status = 6;
   */ _define_property(this, "status", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(FileInfo, "runtime", proto3);
_define_property(FileInfo, "typeName", "mono.agent.v1.FileInfo");
_define_property(FileInfo, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "content_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "size",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 5,
            name: "chunk_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.agent.v1.FileChunk
 */ export class FileChunk extends Message$1 {
    static fromBinary(bytes, options) {
        return new FileChunk().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FileChunk().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FileChunk().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FileChunk, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string content = 2;
   */ _define_property(this, "content", ""), /**
   * @generated from field: int32 index = 3;
   */ _define_property(this, "index", 0), /**
   * @generated from field: map<string, string> metadata = 4;
   */ _define_property(this, "metadata", {});
        proto3.util.initPartial(data, this);
    }
}
_define_property(FileChunk, "runtime", proto3);
_define_property(FileChunk, "typeName", "mono.agent.v1.FileChunk");
_define_property(FileChunk, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "content",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "index",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "metadata",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 9 /* ScalarType.STRING */ 
            }
        }
    ]));
/**
 * @generated from message mono.agent.v1.GetProjectContextRequest
 */ export class GetProjectContextRequest extends Message$1 {
    static fromBinary(bytes, options) {
        return new GetProjectContextRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProjectContextRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProjectContextRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProjectContextRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProjectContextRequest, "runtime", proto3);
_define_property(GetProjectContextRequest, "typeName", "mono.agent.v1.GetProjectContextRequest");
_define_property(GetProjectContextRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.agent.v1.GetProjectContextResponse
 */ export class GetProjectContextResponse extends Message$1 {
    static fromBinary(bytes, options) {
        return new GetProjectContextResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProjectContextResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProjectContextResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProjectContextResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: google.protobuf.Struct context = 1;
   */ _define_property(this, "context", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProjectContextResponse, "runtime", proto3);
_define_property(GetProjectContextResponse, "typeName", "mono.agent.v1.GetProjectContextResponse");
_define_property(GetProjectContextResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "context",
            kind: "message",
            T: Struct
        }
    ]));
/**
 * @generated from message mono.agent.v1.GetSystemPromptRequest
 */ export class GetSystemPromptRequest extends Message$1 {
    static fromBinary(bytes, options) {
        return new GetSystemPromptRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetSystemPromptRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetSystemPromptRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetSystemPromptRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetSystemPromptRequest, "runtime", proto3);
_define_property(GetSystemPromptRequest, "typeName", "mono.agent.v1.GetSystemPromptRequest");
_define_property(GetSystemPromptRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.agent.v1.GetSystemPromptResponse
 */ export class GetSystemPromptResponse extends Message$1 {
    static fromBinary(bytes, options) {
        return new GetSystemPromptResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetSystemPromptResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetSystemPromptResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetSystemPromptResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string system_prompt = 1;
   */ _define_property(this, "systemPrompt", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string project_type = 3;
   */ _define_property(this, "projectType", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetSystemPromptResponse, "runtime", proto3);
_define_property(GetSystemPromptResponse, "typeName", "mono.agent.v1.GetSystemPromptResponse");
_define_property(GetSystemPromptResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "system_prompt",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "project_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.agent.v1.GetChatModelSettingsRequest
 */ export class GetChatModelSettingsRequest extends Message$1 {
    static fromBinary(bytes, options) {
        return new GetChatModelSettingsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetChatModelSettingsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetChatModelSettingsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetChatModelSettingsRequest, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetChatModelSettingsRequest, "runtime", proto3);
_define_property(GetChatModelSettingsRequest, "typeName", "mono.agent.v1.GetChatModelSettingsRequest");
_define_property(GetChatModelSettingsRequest, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.agent.v1.GetChatModelSettingsResponse
 */ export class GetChatModelSettingsResponse extends Message$1 {
    static fromBinary(bytes, options) {
        return new GetChatModelSettingsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetChatModelSettingsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetChatModelSettingsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetChatModelSettingsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * Stored values ("" when unset / never written).
   *
   * @generated from field: string main_model_id = 1;
   */ _define_property(this, "mainModelId", ""), /**
   * @generated from field: string subagent_model_id = 2;
   */ _define_property(this, "subagentModelId", ""), /**
   * Effective values after the fallback cascade (stored id must exist in the
   * catalog AND its provider must be registered; subagent falls back to main,
   * main falls back to the compiled default).
   *
   * @generated from field: string effective_main_model_id = 3;
   */ _define_property(this, "effectiveMainModelId", ""), /**
   * @generated from field: string effective_subagent_model_id = 4;
   */ _define_property(this, "effectiveSubagentModelId", ""), /**
   * Catalog filtered to providers with an API key loaded — the switcher's
   * option list.
   *
   * @generated from field: repeated mono.agent.v1.Model available_models = 5;
   */ _define_property(this, "availableModels", []), /**
   * @generated from field: string updated_by_user_id = 6;
   */ _define_property(this, "updatedByUserId", ""), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetChatModelSettingsResponse, "runtime", proto3);
_define_property(GetChatModelSettingsResponse, "typeName", "mono.agent.v1.GetChatModelSettingsResponse");
_define_property(GetChatModelSettingsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "main_model_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "subagent_model_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "effective_main_model_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "effective_subagent_model_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "available_models",
            kind: "message",
            T: Model,
            repeated: true
        },
        {
            no: 6,
            name: "updated_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.agent.v1.UpdateChatModelSettingsRequest
 */ export class UpdateChatModelSettingsRequest extends Message$1 {
    static fromBinary(bytes, options) {
        return new UpdateChatModelSettingsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateChatModelSettingsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateChatModelSettingsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateChatModelSettingsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * required; validated against the catalog + registry
   *
   * @generated from field: string main_model_id = 1;
   */ _define_property(this, "mainModelId", ""), /**
   * "" => same as main
   *
   * @generated from field: string subagent_model_id = 2;
   */ _define_property(this, "subagentModelId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateChatModelSettingsRequest, "runtime", proto3);
_define_property(UpdateChatModelSettingsRequest, "typeName", "mono.agent.v1.UpdateChatModelSettingsRequest");
_define_property(UpdateChatModelSettingsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "main_model_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "subagent_model_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.agent.v1.UpdateChatModelSettingsResponse
 */ export class UpdateChatModelSettingsResponse extends Message$1 {
    static fromBinary(bytes, options) {
        return new UpdateChatModelSettingsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateChatModelSettingsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateChatModelSettingsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateChatModelSettingsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.agent.v1.GetChatModelSettingsResponse settings = 1;
   */ _define_property(this, "settings", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateChatModelSettingsResponse, "runtime", proto3);
_define_property(UpdateChatModelSettingsResponse, "typeName", "mono.agent.v1.UpdateChatModelSettingsResponse");
_define_property(UpdateChatModelSettingsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "settings",
            kind: "message",
            T: GetChatModelSettingsResponse
        }
    ]));
/**
 * @generated from message mono.agent.v1.TokenUsageTotals
 */ export class TokenUsageTotals extends Message$1 {
    static fromBinary(bytes, options) {
        return new TokenUsageTotals().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TokenUsageTotals().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TokenUsageTotals().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TokenUsageTotals, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int64 prompt_tokens = 1;
   */ _define_property(this, "promptTokens", protoInt64.zero), /**
   * @generated from field: int64 completion_tokens = 2;
   */ _define_property(this, "completionTokens", protoInt64.zero), /**
   * @generated from field: int64 total_tokens = 3;
   */ _define_property(this, "totalTokens", protoInt64.zero), /**
   * @generated from field: int64 event_count = 4;
   */ _define_property(this, "eventCount", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(TokenUsageTotals, "runtime", proto3);
_define_property(TokenUsageTotals, "typeName", "mono.agent.v1.TokenUsageTotals");
_define_property(TokenUsageTotals, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "prompt_tokens",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 2,
            name: "completion_tokens",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 3,
            name: "total_tokens",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 4,
            name: "event_count",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * day is "YYYY-MM-DD" (UTC bucket).
 *
 * @generated from message mono.agent.v1.TokenUsageDay
 */ export class TokenUsageDay extends Message$1 {
    static fromBinary(bytes, options) {
        return new TokenUsageDay().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TokenUsageDay().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TokenUsageDay().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TokenUsageDay, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string day = 1;
   */ _define_property(this, "day", ""), /**
   * @generated from field: mono.agent.v1.TokenUsageTotals totals = 2;
   */ _define_property(this, "totals", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(TokenUsageDay, "runtime", proto3);
_define_property(TokenUsageDay, "typeName", "mono.agent.v1.TokenUsageDay");
_define_property(TokenUsageDay, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "day",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "totals",
            kind: "message",
            T: TokenUsageTotals
        }
    ]));
/**
 * key is a model_id (by_model) or source value "chat"|"subagent" (by_source).
 *
 * @generated from message mono.agent.v1.TokenUsageBucket
 */ export class TokenUsageBucket extends Message$1 {
    static fromBinary(bytes, options) {
        return new TokenUsageBucket().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TokenUsageBucket().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TokenUsageBucket().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TokenUsageBucket, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string key = 1;
   */ _define_property(this, "key", ""), /**
   * @generated from field: mono.agent.v1.TokenUsageTotals totals = 2;
   */ _define_property(this, "totals", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(TokenUsageBucket, "runtime", proto3);
_define_property(TokenUsageBucket, "typeName", "mono.agent.v1.TokenUsageBucket");
_define_property(TokenUsageBucket, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "totals",
            kind: "message",
            T: TokenUsageTotals
        }
    ]));
/**
 * @generated from message mono.agent.v1.GetTokenUsageSummaryRequest
 */ export class GetTokenUsageSummaryRequest extends Message$1 {
    static fromBinary(bytes, options) {
        return new GetTokenUsageSummaryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetTokenUsageSummaryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetTokenUsageSummaryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetTokenUsageSummaryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * unset => epoch
   *
   * @generated from field: google.protobuf.Timestamp start = 1;
   */ _define_property(this, "start", void 0), /**
   * unset => now
   *
   * @generated from field: google.protobuf.Timestamp end = 2;
   */ _define_property(this, "end", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetTokenUsageSummaryRequest, "runtime", proto3);
_define_property(GetTokenUsageSummaryRequest, "typeName", "mono.agent.v1.GetTokenUsageSummaryRequest");
_define_property(GetTokenUsageSummaryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "start",
            kind: "message",
            T: Timestamp
        },
        {
            no: 2,
            name: "end",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.agent.v1.GetTokenUsageSummaryResponse
 */ export class GetTokenUsageSummaryResponse extends Message$1 {
    static fromBinary(bytes, options) {
        return new GetTokenUsageSummaryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetTokenUsageSummaryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetTokenUsageSummaryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetTokenUsageSummaryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.agent.v1.TokenUsageTotals totals = 1;
   */ _define_property(this, "totals", void 0), /**
   * @generated from field: repeated mono.agent.v1.TokenUsageDay days = 2;
   */ _define_property(this, "days", []), /**
   * @generated from field: repeated mono.agent.v1.TokenUsageBucket by_model = 3;
   */ _define_property(this, "byModel", []), /**
   * @generated from field: repeated mono.agent.v1.TokenUsageBucket by_source = 4;
   */ _define_property(this, "bySource", []), /**
   * distinct users with usage in range
   *
   * @generated from field: int64 active_users = 5;
   */ _define_property(this, "activeUsers", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetTokenUsageSummaryResponse, "runtime", proto3);
_define_property(GetTokenUsageSummaryResponse, "typeName", "mono.agent.v1.GetTokenUsageSummaryResponse");
_define_property(GetTokenUsageSummaryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "totals",
            kind: "message",
            T: TokenUsageTotals
        },
        {
            no: 2,
            name: "days",
            kind: "message",
            T: TokenUsageDay,
            repeated: true
        },
        {
            no: 3,
            name: "by_model",
            kind: "message",
            T: TokenUsageBucket,
            repeated: true
        },
        {
            no: 4,
            name: "by_source",
            kind: "message",
            T: TokenUsageBucket,
            repeated: true
        },
        {
            no: 5,
            name: "active_users",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.agent.v1.ListUserTokenUsageRequest
 */ export class ListUserTokenUsageRequest extends Message$1 {
    static fromBinary(bytes, options) {
        return new ListUserTokenUsageRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListUserTokenUsageRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListUserTokenUsageRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListUserTokenUsageRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: google.protobuf.Timestamp start = 1;
   */ _define_property(this, "start", void 0), /**
   * @generated from field: google.protobuf.Timestamp end = 2;
   */ _define_property(this, "end", void 0), /**
   * matches email/name
   *
   * @generated from field: string search = 3;
   */ _define_property(this, "search", ""), /**
   * default 50, cap 200
   *
   * @generated from field: int32 limit = 4;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: int32 offset = 5;
   */ _define_property(this, "offset", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListUserTokenUsageRequest, "runtime", proto3);
_define_property(ListUserTokenUsageRequest, "typeName", "mono.agent.v1.ListUserTokenUsageRequest");
_define_property(ListUserTokenUsageRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "start",
            kind: "message",
            T: Timestamp
        },
        {
            no: 2,
            name: "end",
            kind: "message",
            T: Timestamp
        },
        {
            no: 3,
            name: "search",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.agent.v1.UserTokenUsage
 */ export class UserTokenUsage extends Message$1 {
    static fromBinary(bytes, options) {
        return new UserTokenUsage().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UserTokenUsage().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UserTokenUsage().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UserTokenUsage, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", ""), /**
   * "" when the identity row no longer exists
   *
   * @generated from field: string email = 2;
   */ _define_property(this, "email", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * @generated from field: mono.agent.v1.TokenUsageTotals totals = 4;
   */ _define_property(this, "totals", void 0), /**
   * @generated from field: google.protobuf.Timestamp last_activity = 5;
   */ _define_property(this, "lastActivity", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UserTokenUsage, "runtime", proto3);
_define_property(UserTokenUsage, "typeName", "mono.agent.v1.UserTokenUsage");
_define_property(UserTokenUsage, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "totals",
            kind: "message",
            T: TokenUsageTotals
        },
        {
            no: 5,
            name: "last_activity",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.agent.v1.ListUserTokenUsageResponse
 */ export class ListUserTokenUsageResponse extends Message$1 {
    static fromBinary(bytes, options) {
        return new ListUserTokenUsageResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListUserTokenUsageResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListUserTokenUsageResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListUserTokenUsageResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.agent.v1.UserTokenUsage users = 1;
   */ _define_property(this, "users", []), /**
   * distinct users in range (for pagination)
   *
   * @generated from field: int32 total_count = 2;
   */ _define_property(this, "totalCount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListUserTokenUsageResponse, "runtime", proto3);
_define_property(ListUserTokenUsageResponse, "typeName", "mono.agent.v1.ListUserTokenUsageResponse");
_define_property(ListUserTokenUsageResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "users",
            kind: "message",
            T: UserTokenUsage,
            repeated: true
        },
        {
            no: 2,
            name: "total_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.agent.v1.Memory
 */ export class Memory extends Message$1 {
    static fromBinary(bytes, options) {
        return new Memory().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Memory().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Memory().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Memory, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * personal | project | team
   *
   * @generated from field: string kind = 2;
   */ _define_property(this, "kind", ""), /**
   * set for personal
   *
   * @generated from field: string owner_user_id = 3;
   */ _define_property(this, "ownerUserId", ""), /**
   * @generated from field: string scope_kind = 4;
   */ _define_property(this, "scopeKind", ""), /**
   * @generated from field: string scope_id = 5;
   */ _define_property(this, "scopeId", ""), /**
   * @generated from field: string title = 6;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string body = 7;
   */ _define_property(this, "body", ""), /**
   * @generated from field: string created_by = 8;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: string updated_by = 9;
   */ _define_property(this, "updatedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 11;
   */ _define_property(this, "updatedAt", void 0), /**
   * active | pending | rejected (pending/rejected: team only)
   *
   * @generated from field: string status = 12;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string decided_by = 13;
   */ _define_property(this, "decidedBy", ""), /**
   * @generated from field: string decision_note = 14;
   */ _define_property(this, "decisionNote", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(Memory, "runtime", proto3);
_define_property(Memory, "typeName", "mono.agent.v1.Memory");
_define_property(Memory, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "owner_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "scope_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "scope_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "body",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "updated_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "decided_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "decision_note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.agent.v1.ListMemoriesRequest
 */ export class ListMemoriesRequest extends Message$1 {
    static fromBinary(bytes, options) {
        return new ListMemoriesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListMemoriesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListMemoriesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListMemoriesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * optional project bind (pursuit | zou_project | program); "team" lists team notes
   *
   * @generated from field: string scope_kind = 1;
   */ _define_property(this, "scopeKind", ""), /**
   * @generated from field: string scope_id = 2;
   */ _define_property(this, "scopeId", ""), /**
   * team list: active (default) | pending (admins) | rejected
   *
   * @generated from field: string status = 3;
   */ _define_property(this, "status", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListMemoriesRequest, "runtime", proto3);
_define_property(ListMemoriesRequest, "typeName", "mono.agent.v1.ListMemoriesRequest");
_define_property(ListMemoriesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "scope_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "scope_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.agent.v1.ListMemoriesResponse
 */ export class ListMemoriesResponse extends Message$1 {
    static fromBinary(bytes, options) {
        return new ListMemoriesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListMemoriesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListMemoriesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListMemoriesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.agent.v1.Memory memories = 1;
   */ _define_property(this, "memories", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListMemoriesResponse, "runtime", proto3);
_define_property(ListMemoriesResponse, "typeName", "mono.agent.v1.ListMemoriesResponse");
_define_property(ListMemoriesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "memories",
            kind: "message",
            T: Memory,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.agent.v1.UpsertMemoryRequest
 */ export class UpsertMemoryRequest extends Message$1 {
    static fromBinary(bytes, options) {
        return new UpsertMemoryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertMemoryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertMemoryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertMemoryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * empty => create
   *
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * personal | project
   *
   * @generated from field: string kind = 2;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string scope_kind = 3;
   */ _define_property(this, "scopeKind", ""), /**
   * @generated from field: string scope_id = 4;
   */ _define_property(this, "scopeId", ""), /**
   * @generated from field: string title = 5;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string body = 6;
   */ _define_property(this, "body", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertMemoryRequest, "runtime", proto3);
_define_property(UpsertMemoryRequest, "typeName", "mono.agent.v1.UpsertMemoryRequest");
_define_property(UpsertMemoryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "scope_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "scope_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "body",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.agent.v1.UpsertMemoryResponse
 */ export class UpsertMemoryResponse extends Message$1 {
    static fromBinary(bytes, options) {
        return new UpsertMemoryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertMemoryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertMemoryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertMemoryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.agent.v1.Memory memory = 1;
   */ _define_property(this, "memory", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertMemoryResponse, "runtime", proto3);
_define_property(UpsertMemoryResponse, "typeName", "mono.agent.v1.UpsertMemoryResponse");
_define_property(UpsertMemoryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "memory",
            kind: "message",
            T: Memory
        }
    ]));
/**
 * @generated from message mono.agent.v1.DeleteMemoryRequest
 */ export class DeleteMemoryRequest extends Message$1 {
    static fromBinary(bytes, options) {
        return new DeleteMemoryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteMemoryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteMemoryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteMemoryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * The note's scope; required for project and team notes (access is checked).
   *
   * @generated from field: string scope_kind = 2;
   */ _define_property(this, "scopeKind", ""), /**
   * @generated from field: string scope_id = 3;
   */ _define_property(this, "scopeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteMemoryRequest, "runtime", proto3);
_define_property(DeleteMemoryRequest, "typeName", "mono.agent.v1.DeleteMemoryRequest");
_define_property(DeleteMemoryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "scope_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "scope_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.agent.v1.DeleteMemoryResponse
 */ export class DeleteMemoryResponse extends Message$1 {
    static fromBinary(bytes, options) {
        return new DeleteMemoryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteMemoryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteMemoryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteMemoryResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteMemoryResponse, "runtime", proto3);
_define_property(DeleteMemoryResponse, "typeName", "mono.agent.v1.DeleteMemoryResponse");
_define_property(DeleteMemoryResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.agent.v1.DecideTeamMemoryRequest
 */ export class DecideTeamMemoryRequest extends Message$1 {
    static fromBinary(bytes, options) {
        return new DecideTeamMemoryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DecideTeamMemoryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DecideTeamMemoryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DecideTeamMemoryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool approve = 2;
   */ _define_property(this, "approve", false), /**
   * @generated from field: string note = 3;
   */ _define_property(this, "note", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DecideTeamMemoryRequest, "runtime", proto3);
_define_property(DecideTeamMemoryRequest, "typeName", "mono.agent.v1.DecideTeamMemoryRequest");
_define_property(DecideTeamMemoryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "approve",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.agent.v1.DecideTeamMemoryResponse
 */ export class DecideTeamMemoryResponse extends Message$1 {
    static fromBinary(bytes, options) {
        return new DecideTeamMemoryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DecideTeamMemoryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DecideTeamMemoryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DecideTeamMemoryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.agent.v1.Memory memory = 1;
   */ _define_property(this, "memory", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DecideTeamMemoryResponse, "runtime", proto3);
_define_property(DecideTeamMemoryResponse, "typeName", "mono.agent.v1.DecideTeamMemoryResponse");
_define_property(DecideTeamMemoryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "memory",
            kind: "message",
            T: Memory
        }
    ]));
/**
 * @generated from message mono.agent.v1.ChatSubmissionStatus
 */ export class ChatSubmissionStatus extends Message$1 {
    static fromBinary(bytes, options) {
        return new ChatSubmissionStatus().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ChatSubmissionStatus().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ChatSubmissionStatus().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ChatSubmissionStatus, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string submission_id = 1;
   */ _define_property(this, "submissionId", ""), /**
   * running, done, awaiting_approval, interrupted, failed, or incomplete.
   *
   * @generated from field: string state = 2;
   */ _define_property(this, "state", ""), /**
   * @generated from field: google.protobuf.Timestamp lease_expires_at = 3;
   */ _define_property(this, "leaseExpiresAt", void 0), /**
   * @generated from field: bool stop_requested = 4;
   */ _define_property(this, "stopRequested", false), /**
   * Original customer input, for an identity-preserving retry after refresh.
   *
   * @generated from field: string message = 5;
   */ _define_property(this, "message", ""), /**
   * @generated from field: repeated string file_ids = 6;
   */ _define_property(this, "fileIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ChatSubmissionStatus, "runtime", proto3);
_define_property(ChatSubmissionStatus, "typeName", "mono.agent.v1.ChatSubmissionStatus");
_define_property(ChatSubmissionStatus, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "submission_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "lease_expires_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "stop_requested",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "file_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.agent.v1.StopChatSubmissionRequest
 */ export class StopChatSubmissionRequest extends Message$1 {
    static fromBinary(bytes, options) {
        return new StopChatSubmissionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StopChatSubmissionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StopChatSubmissionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StopChatSubmissionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string conversation_id = 1;
   */ _define_property(this, "conversationId", ""), /**
   * @generated from field: string submission_id = 2;
   */ _define_property(this, "submissionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(StopChatSubmissionRequest, "runtime", proto3);
_define_property(StopChatSubmissionRequest, "typeName", "mono.agent.v1.StopChatSubmissionRequest");
_define_property(StopChatSubmissionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "conversation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "submission_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.agent.v1.StopChatSubmissionResponse
 */ export class StopChatSubmissionResponse extends Message$1 {
    static fromBinary(bytes, options) {
        return new StopChatSubmissionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StopChatSubmissionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StopChatSubmissionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StopChatSubmissionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.agent.v1.ChatSubmissionStatus submission = 1;
   */ _define_property(this, "submission", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(StopChatSubmissionResponse, "runtime", proto3);
_define_property(StopChatSubmissionResponse, "typeName", "mono.agent.v1.StopChatSubmissionResponse");
_define_property(StopChatSubmissionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "submission",
            kind: "message",
            T: ChatSubmissionStatus
        }
    ]));
